export default __webpack_public_path__ + "static/media/map.a1262f60.png";